module.exports = __webpack_public_path__ + "static/media/menu.6d6d5c19.svg";